import {
	createRefreshedDonePlatformState,
	createRefreshedIdlePlatformState,
	getPlatformResultFromShotlist
} from '@/features/FormUploader/helpers/platformHeaderState'
import { IShotlist } from '@/types/shotlist.interface'
import { ISelectedPlatform } from '@/types/uploadForm.interface'

export const refreshFormHeaderState = ({
	prev,
	shotlist
}: {
	prev: ISelectedPlatform[]
	shotlist: IShotlist
}): { next: ISelectedPlatform[]; changed: boolean } => {
	let changed = false

	const next: ISelectedPlatform[] = prev.map(p => {
		if (p.headerState === 'error') return p

		const result = getPlatformResultFromShotlist({
			value: p.value,
			shotlist
		})

		if (result) {
			if (p.headerState !== 'done' || p.result !== result) {
				changed = true
				return createRefreshedDonePlatformState({
					platform: p,
					result
				})
			}
			return p
		}

		if (p.headerState === 'processing') return p

		// If there is no language - reset done back to idle
		const isStaleDone = p.headerState === 'done' || p.result !== undefined
		if (isStaleDone) {
			changed = true
			return createRefreshedIdlePlatformState({
				platform: p
			})
		}

		return p
	})

	return { next, changed }
}
